import type { SectionDraft } from "@procurement-agents/scope-api";

const PLACEHOLDER = /\[TO CONFIRM[^\]]*\]/gi;

/** Open `[TO CONFIRM: …]` items across the draft (PLAN_venueswest A): what someone still has to supply. */
export function countPlaceholders(sections: Array<Pick<SectionDraft, "content">>): number {
  return sections.reduce((n, s) => n + (s.content?.match(PLACEHOLDER)?.length ?? 0), 0);
}

export const toConfirm = (n: number) => `${n} item${n === 1 ? "" : "s"} still to confirm`;
